/**
 * 空状態（§0.3.2「空状態」）。染色体級はファイル取込が主 CTA。
 */

import { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ACCEPTED_SEQUENCE_EXTENSIONS } from './GeneAnalysisToolbar';

export interface GeneAnalysisEmptyStateProps {
  onImportFile: (file: File) => void;
  onOpenDemo: () => void;
  importing: boolean;
}

export default function GeneAnalysisEmptyState({
  onImportFile,
  onOpenDemo,
  importing,
}: GeneAnalysisEmptyStateProps) {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className="ga-empty" data-testid="gene-analysis-empty">
      <h2 className="ga-empty-title">{t('geneAnalysis.empty.title')}</h2>
      <p className="ga-empty-lead">{t('geneAnalysis.empty.lead')}</p>

      <input
        ref={fileInputRef}
        type="file"
        accept={ACCEPTED_SEQUENCE_EXTENSIONS}
        className="d-none"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onImportFile(file);
          event.target.value = '';
        }}
      />

      <div className="ga-empty-actions">
        <Button
          variant="primary"
          size="lg"
          disabled={importing}
          onClick={() => fileInputRef.current?.click()}
          data-testid="gene-analysis-empty-import"
        >
          {t('geneAnalysis.empty.import')}
        </Button>
        <Button variant="outline-secondary" disabled={importing} onClick={onOpenDemo}>
          {t('geneAnalysis.empty.demo')}
        </Button>
      </div>

      <p className="ga-empty-note">{t('geneAnalysis.empty.note')}</p>
    </div>
  );
}
